import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  startGetAsistenciaInicial,
  startCapturaTerminada,
  setCrearServiciosV2Captura,
} from "../../../context/actions/crearServiciosV2Actions";
import { esEmailValido } from "../../../utils/esEmailValido";

export const useEditarServicioV2 = () => {
  const { asistenciaID } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { captura, capturaCampos } = useSelector((state) => state.asistenciasReducer);
  const [validandoAcceso, setValidandoAcceso] = useState(true);
  const [valoresCampos, setValoresCampos] = useState({});
  const [loadingTerminar, setLoadingTerminar] = useState(false);
  const [ubicacionGuardada, setUbicacionGuardada] = useState(false);
  const datosServicioRef = useRef(null);

  useEffect(() => {
    let activo = true;

    const cargarAsistencia = async () => {
      const result = await dispatch(startGetAsistenciaInicial(asistenciaID));

      if (!activo) return;

      const estatusFinalID = Number(result?.data?.estatusFinalID);
      const estatusID = Number(result?.data?.estatusID);

      if (!result?.success || estatusFinalID !== 1 || estatusID !== 1) {
        history.replace(`/detalleAsistencia/${asistenciaID}`);
        return;
      }

      setValidandoAcceso(false);
    };

    if (asistenciaID) {
      cargarAsistencia();
    }

    return () => {
      activo = false;
    };
  }, [asistenciaID, dispatch, history]);

  useEffect(() => {
    if (ubicacionGuardada && datosServicioRef.current) {
      datosServicioRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [ubicacionGuardada]);

  useEffect(() => {
    if (!capturaCampos || capturaCampos.length === 0) return;
    if (!captura.numero_serie) return;
    
    const campoNumeroSerie = capturaCampos.find(c => c.label === "Numero Serie");
    if (!campoNumeroSerie) return;
    
    const campoId = campoNumeroSerie.id;
    if (!valoresCampos[campoId]) {
      setValoresCampos(prev => ({ ...prev, [campoId]: captura.numero_serie }));
    }
  }, [capturaCampos, captura.numero_serie]);

  const handleInputChange = (campo) => (e) => {
    dispatch(setCrearServiciosV2Captura({ [campo]: e.target.value }));
  };

  const handleSelectChange = (campo) => (value) => {
    dispatch(setCrearServiciosV2Captura({ [campo]: value }));
  };

  const handleCampoChange = (campoId, value) => {
    setValoresCampos((prev) => ({ ...prev, [campoId]: value }));
  };

  const handleTerminar = async () => {
    const camposMapeados = {};
    (capturaCampos || []).forEach((campo, index) => {
      camposMapeados[`campo${index + 1}`] = `${campo.label}: ${valoresCampos[campo.id] || ""}`;
    });

    const { noEncontradoPolizario: _noEncontradoPolizario, ...capturaRest } = captura;
    const body = {
      ...capturaRest,
      asistenciaID,
      ct_uid: captura.ct_uid,
      datosAdicionales: captura.datosAdicionales || "",
      ...camposMapeados,
    };

    setLoadingTerminar(true);
    const result = await dispatch(startCapturaTerminada(body));
    setLoadingTerminar(false);

    if (result?.success) {
      history.push(`/detalleAsistencia/${asistenciaID}`);
    }
  };

  const tieneErroresNumeroSerie = (capturaCampos || []).some((campo) => {
    if (campo.label !== "Numero Serie") return false;
    const val = valoresCampos[campo.id];
    return val && val.length !== 16 && val.length !== 17;
  });
  const tieneErroresEmail = Boolean(captura.email && !esEmailValido(captura.email));
  const tieneErroresCaptura = tieneErroresNumeroSerie || tieneErroresEmail;

  return {
    asistenciaID,
    validandoAcceso,
    valoresCampos,
    loadingTerminar,
    ubicacionGuardada,
    setUbicacionGuardada,
    datosServicioRef,
    handleInputChange,
    handleSelectChange,
    handleCampoChange,
    handleTerminar,
    campaniaID: captura.campaniaID,
    tieneErroresCaptura,
    datosAdicionales: captura.datosAdicionales,
  };
};
